// extracted by mini-css-extract-plugin
module.exports = {"code":"dataTestId_code__Hn7aE"};